import { useLocalObservable } from 'mobx-react-lite';
import { AiConnectionStore } from '../../stores/ai-adapter.store';

export const useAi = () => {
    const store = useLocalObservable(() => new AiConnectionStore());

    // Stable method refs (arrow + autoBind) — do not .bind() per render.
    return {
        askAi: store.ask,
        loadHistory: store.history,
        loading: store.loading,
        historyLoading: store.historyLoading,
        chatLoading: store.chatLoading,
        error: store.error,
    };
};
